import {KEY_DEVICE_ID, KEY_USER_ID, KEY_TOKEN, LAST_MESSAGE_SEQ, SEND_MESSAGE_COUNT, FRIEND_REQUEST_VERSION, SEND_MESSAGE_ID, USER_INFO_LIST, USER_MESSAGES, USER_CONVERSATIONS} from "../constant/system"
export default class LocalStore{

    static setDeviceId(deviceId){
        localStorage.setItem(KEY_DEVICE_ID,deviceId)
    }

    static getDeviceId(){
        return localStorage.getItem(KEY_DEVICE_ID);
    }

    static setUserId(userId){
        localStorage.setItem(KEY_USER_ID,userId)
    }

    static getUserId(){
        return localStorage.getItem(KEY_USER_ID)
    }

    static setToken(token){
        localStorage.setItem(KEY_TOKEN,token)
    }

    static getToken(){
        return localStorage.getItem(KEY_TOKEN)
    }

    static isLogin(){
        return this.getToken() && this.getToken() != ''
    }

    static getLastMessageSeq(){
        return localStorage.getItem(LAST_MESSAGE_SEQ);
    }

    /**
     * messageSeq为string类型
     */
    static setLastMessageSeq(messageSeq){
        localStorage.setItem(LAST_MESSAGE_SEQ,messageSeq);
    }

    static getSendMessageCount(){
        let value = localStorage.getItem(SEND_MESSAGE_COUNT);
        if(!value){
            value = 0;
        }
        return value;
    }

    /**
     * 记录消息发送条数主要时为了
     */
    static updateSendMessageCount(){
        let value = localStorage.getItem(SEND_MESSAGE_COUNT);
        if(value){
            value  = parseInt(value) + 1;
        } else {
            value = 1;
        }
        localStorage.setItem(SEND_MESSAGE_COUNT,value);
    }

    static resetSendMessageCount(){
        localStorage.setItem(SEND_MESSAGE_COUNT,0);
    }

    static setFriendRequestVersion(version){
        localStorage.setItem(FRIEND_REQUEST_VERSION,version);
    }

    static getFriendRequestVersion(){
        return localStorage.getItem(FRIEND_REQUEST_VERSION);
    }

    static saveMessageId(messageId){
        localStorage.setItem(SEND_MESSAGE_ID,messageId);
     }
 
     static getMessageId(){
         var messageId = localStorage.getItem(SEND_MESSAGE_ID);
         if(!messageId){
             messageId = 0;
         }
         return messageId;
     }

    static saveUserInfoList(value){
        localStorage.setItem(USER_INFO_LIST,JSON.stringify(value));
    }

    static getUserInfoList(){
        let value = localStorage.getItem(USER_INFO_LIST);
        return JSON.parse(value);
    }

    static saveMessages(value){
        localStorage.setItem(USER_MESSAGES,JSON.stringify(value));
    }

    static getMessages(){
        let value = localStorage.getItem(USER_MESSAGES);
        return JSON.parse(value);
    }

    static saveConverSations(value){
        localStorage.setItem(USER_CONVERSATIONS,JSON.stringify(value));
    }

    static getConversations(){
        let vaule = localStorage.getItem(USER_CONVERSATIONS);
        return JSON.parse(vaule);
    }

    static clearLocalStore(){
        localStorage.setItem(USER_CONVERSATIONS,"");
        localStorage.setItem(LAST_MESSAGE_SEQ,"");
        localStorage.setItem(USER_MESSAGES,"");
        localStorage.setItem(SEND_MESSAGE_COUNT,0);
        // localStorage.setItem("select_target","");
        localStorage.setItem(FRIEND_REQUEST_VERSION,0);
        localStorage.setItem(KEY_USER_ID,'');
        localStorage.setItem(KEY_TOKEN,"");
        this.setLastMessageSeq(0)
        this.saveUserInfoList("")
    }
}


// WEBPACK FOOTER //
// ./src/fscommon/utils/localstore.js